import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import MainLayout from "../../nav/MainLayout";
import FormProgress from "../AuditAdmin/FormProgress";
import { useSetRecoilState } from "recoil";
import { styled } from "@mui/material/styles";
import Footer from "../../reusables/Footer";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./TechReviewerAudit.scss";
import FormDetailsTable from "../UnitAdmin/FormDetailsTable";
import ProtocolDetails from "./protocol-details/ProtocolDetails";
import ScoringDetails from "./scoring-details/ScoringDetails";
import AuditDetailsTable from "./AuditDetailsTable";
import { useSearchParams } from "react-router-dom";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import DummyData from "./TechReviewerDummydata.json";
import { Alert } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import iconLoading from "../../../assets/img/Loader5.gif";
import CommonTableOne from "./protocol-details/CommonTableOne";
import CommonTableTwo from "./protocol-details/CommonTableTwo";
import responseSubmit from "../../../assets/img/Response-Submit.gif";
import { formProgress } from "../../../store/atoms";
import { login } from "../../auth/msalAuth";
import AuditDetailsCorrectionTable from "./AuditDetailsCorrectionTable";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import UploadFile from "./UploadFile";
// import TechReviewerNewExport from "../../reusables/TechReviewerNewExport";
import TechReviewerNewExport from "../../reusables/Model/TechReviewerNewExport";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

const TechReviewerAudit = () => {
  const progressUpdate = useSetRecoilState(formProgress);
  const [expanded, setExpanded] = useState([false, false, false, false]);
  const [openPopup, setOpenPopup] = useState(false);
  const [openCorrectionPopup, setOpenCorrectionPopup] = useState(false);
  const [verificationData, setVerificationData] = useState(null);
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [verificationError, setVerificationError] = useState(false);
  const [correctionData1, setCorrectionData1] = useState([]);
  const [correctionData2, setCorrectionData2] = useState([]);
  const [auditDetailsCorrections, setAuditDetailsCorrections] = useState([]);
  const [areaConcernPl, setAreaConcernPl] = useState([]);
  const [ffscFindingPl, setFfscFindingsPl] = useState([]);
  const [focusAreaPl, setFocusAreaPl] = useState([]);
  const [scoringDetailsPl, setScoringDetailsPl] = useState([]);
  const [auditConclusionPl, setAuditConclusionPl] = useState([]);
  const [protocolDetailsPl, setProtocolDetailsPl] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitError, setSubmitError] = useState(false);
  const [submitData, setSubmitData] = useState(false);
  const [error, setError] = useState(false);
  const [unitIndex, setUnitIndex] = useState("");
  const [version, setVersion] = useState();
  const [sendBackPopupFlag, setSendBackPopupFlag] = useState(false);
  const [searchParams] = useSearchParams();
  const auditNumber = searchParams.get("auditNumber");
  // const auditNumber = "2025-0005";

  const getVerificationDetails = async () => {
    const getScoringURL = `${process.env.REACT_APP_SERVER_URL}/api/review/getform/${auditNumber}`;
    const token = await getToken();
    // console.log('Token: ', token)
    setVerificationLoading(true);
    try {
      const response = await axios.get(getScoringURL, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        let updatedResponse = response.data;
        updatedResponse = {
          ...updatedResponse,
          auditDetails: transformAuditData(updatedResponse?.auditDetails),
        };
        setVerificationData(updatedResponse);
        // Set sendBackPopupFlag based on correctionData2 with isPreviousYear=true
        // This will be updated when correctionData2 changes
        setVerificationLoading(false);
      } else {
        setVerificationError("Oops! Something went wrong. . .");
        setVerificationLoading(false);
      }
    } catch (e) {
      setVerificationLoading(false);
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      setVerificationError("Oops! Something went wrong. . .");
    } finally {
      setVerificationError(false);
    }
  };

  // console.log("Verification Data: ", verificationData);

  const submitForm = async (activity) => {
    setSubmitLoading(true);
    try {
      let payload = null;
      if (activity === "allGood") {
        payload = { formId: auditNumber };
      } else {
        payload = {
          formId: auditNumber,
          protocolDetails: protocolDetailsPl,
          areasOfConcern: areaConcernPl,
          ffscFindings: ffscFindingPl,
          focusArea: focusAreaPl,
          scoringDetails:
            auditConclusionPl.length > 0 &&
            auditConclusionPl.includes("fsscCertification")
              ? [auditNumber]
              : [],
          auditConclusion: auditConclusionPl,
          auditDetails: auditDetailsCorrections
            .filter(item => item.selectedStatus === "correction")
            .map(item => {
              // Map the label to the expected backend field identifier
              const fieldMapping = {
                "CB Office Location": "cb_office_location",
                "Audit Language": "audit_language",
                "Audit Delivery": "audit_delivery",
                "Audit Start Date": "audit_start_date",
                "Audit End Date": "audit_end_date",
                "Audit Type": "audit_type",
                "Version": "version",
                "Lead Auditor": "lead_auditor",
                "Audit Team": "additional_attendee",
                "Correction Date": "corrective_action_date"
              };
              return fieldMapping[item.label] || item.label.toLowerCase().replace(/\s+/g, '_');
            }),
        };
      }
      let url =
        activity === "allGood"
          ? `${process.env.REACT_APP_SERVER_URL}/api/review/submit`
          : `${process.env.REACT_APP_SERVER_URL}/api/review/sentback
`;
      const token = await getToken();

      const response = await axios.post(url, payload, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        const json = response.data;
        setSubmitData(true);
        setSubmitLoading(false);
        setSubmitError(false);
        if (activity === "allGood") {
          setOpenPopup(false);
        } else {
          setOpenCorrectionPopup(false);
        }
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      console.error("Error while calling the API:", e);
      setSubmitLoading(false);
      setSubmitError(true);
      if (activity === "allGood") {
        setOpenPopup(false);
      } else {
        setOpenCorrectionPopup(false);
      }
    }
  };

  // const formatDate = (dateString) => {
  //   if (!dateString) return "N/A"; // Handle null or undefined values

  //   const date = new Date(dateString);
  //   if (isNaN(date)) return "N/A"; // Handle invalid date strings

  //   const day = date.getDate();
  //   const month = date.toLocaleString("en-US", { month: "long" });
  //   const year = date.getFullYear();

  //   // Function to add ordinal suffix (st, nd, rd, th)
  //   const getOrdinal = (num) => {
  //     if (num > 3 && num < 21) return "th"; // Covers 11th to 20th
  //     switch (num % 10) {
  //       case 1:
  //         return "st";
  //       case 2:
  //         return "nd";
  //       case 3:
  //         return "rd";
  //       default:
  //         return "th";
  //     }
  //   };

  //   return `${day}${getOrdinal(day)} ${month} ${year}`;
  // };

   const formatDate = (dateString) => {
    if (!dateString) return "N/A";
  
    const date = new Date(dateString + "T00:00:00Z"); // force UTC midnight
    if (isNaN(date.getTime())) return "Invalid Date";
  
    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
    const year = date.getUTCFullYear();
  
    const getOrdinal = (num) => {
      if (num > 3 && num < 21) return "th";
      switch (num % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };
  
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };
  function transformAuditData(data) {
    return [
      // {
      //   id: 1,
      //   label: "Activity",
      //   value: data.activity,
      //   verificationStatus: "Verified",
      // },
      {
        id: 10,
        label: "CB Office Location",
        value: data.cb_office_location,
        verificationStatus: "Verified",
      },
      {
        id: 6,
        label: "Audit Language",
        value: data.audit_language,
        verificationStatus: "Verified",
      },
      {
        id: 12,
        label:
          "Will this be done in Conjunction with FSSC Certification Audit ",
        value: data.is_fssc_conjunction ? "Yes" : "No",
        verificationStatus: "Verified",
      },

      {
        id: 2,
        label:
          "Audit Criteria (Applicable Standard or Technical Specifications)",
        value: data.audit_criteria,
        verificationStatus: "Verified",
      },
      {
        id: 3,
        label: "Audit Delivery",
        value: data.audit_delivery.trim(),
        verificationStatus: "Verified",
      },
      {
        id: 7,
        label: "Audit Start Date",
        value: formatDate(data.audit_start_date),
        verificationStatus: "Verified",
      },
      {
        id: 4,
        label: "Audit End Date",
        value: formatDate(data.audit_end_date),
        verificationStatus: "Verified",
      },
      {
        id: 9,
        label: "Audit Type",
        value: data.audit_type,
        verificationStatus: "Verified",
      },
      {
        id: 15,
        label: "Version",
        value: data.version,
        verificationStatus: "Verified",
      },
      {
        id: 19,
        label: "Job Number",
        value: data.jobnumber || 'NA',
        verificationStatus: "Verified",
      },
      {
        id: 5,
        label: "Audit Focus Area",
        value: data.audit_focus_area.join(", "),
        verificationStatus: "Verified",
      },

      {
        id: 16,
        label: "Lead Auditor",
        value: data.lead_auditor,
        verificationStatus: "Verified",
      },
      // {
      //   id: 16,
      //   label: "Functions",
      //   value: data.lead_auditor_function,
      //   verificationStatus: "Verified",
      // },
      {
        id: 17,
        label: "Audit Team",
        value: Object.entries(data.audit_team)
          .map(([name, role]) => `${name}: ${role}`)
          .join(", "),
        verificationStatus: "Verified",
      },
      {
        id: 18,
        label: "Correction Date",
        value: formatDate(data.correction_date),
        verificationStatus: "Verified",
      },

      // {
      //   id: 11,
      //   label: "Form ID",
      //   value: data.form_id,
      //   verificationStatus: "Verified",
      // },

      // {
      //   id: 13,
      //   label: "Lead Auditor",
      //   value: data.lead_auditor,
      //   verificationStatus: "Verified",
      // },
      // {
      //   id: 14,
      //   label: "Lead Auditor Function",
      //   value: data.lead_auditor_function,
      //   verificationStatus: "Verified",
      // },
    ];
  }

  useEffect(() => {
    getVerificationDetails();
    //    const updatedResponse = {
    //   ...DummyData,
    //   auditDetails: transformAuditData(DummyData?.auditDetails),
    // };
    // setVerificationData(updatedResponse)
    progressUpdate((prev) => 4);
  }, []);

  const handleToggle = (index) => {
    setExpanded((prev) =>
      prev.map((value, i) => (i === index ? !value : value))
    );
  };

  const handleRadioButton = (id, changedData, tabName, status, number) => {
    if (tabName === "areasOfConcern" || tabName === "findingsFSSC") {
      if (status === "correction") {
        setCorrectionData2((prev) => {
          return [...prev, changedData];
        });
      } else {
        if (correctionData2.length > 0) {
          setCorrectionData2((prev) => {
            return prev.filter((item) => item.id !== id);
          });
        } else {
          return;
        }
      }
    } else if (tabName === "auditDetails") {
      if (status === "correction") {
        setAuditDetailsCorrections((prev) => {
          // Remove any existing entry with the same id
          const filtered = prev.filter((item) => item.id !== id);
          return [...filtered, changedData];
        });
      } else {
        setAuditDetailsCorrections((prev) => {
          return prev.filter((item) => item.id !== id);
        });
      }
    } else {
      if (tabName === "auditConclusionData") {
        if (status === "correction") {
          setCorrectionData1((prev) => {
            return [...prev, changedData];
          });
        } else {
          if (correctionData1.length > 0) {
            setCorrectionData1((prev) => {
              return prev.filter((item) => item.id !== id);
            });
          } else {
            return;
          }
        }
      } else {
        if (status === "correction") {
          setCorrectionData1((prev) => {
            return [...prev, changedData];
          });
        } else {
          if (correctionData1.length > 0) {
            setCorrectionData1((prev) => {
              return prev.filter((item) => item.id !== id);
            });
          } else {
            return;
          }
        }
      }
    }

    if (status === "correction") {
      switch (tabName) {
        case "findingsFSSC":
          setFfscFindingsPl((prev) => [...prev, number]);
          break;
        case "areasOfConcern":
          setAreaConcernPl((prev) => [...prev, number]);
          break;
        case "auditDetails":
          // Audit details corrections are handled above
          break;
        case "auditConclusionData":
          setAuditConclusionPl((prev) => [...prev, id]);
          break;
        case "focusArea":
          setFocusAreaPl((prev) => [...prev, id]);
          break;
        default:
          setProtocolDetailsPl((prev) => [...prev, id]);
      }
    } else {
      switch (tabName) {
        case "findingsFSSC":
          setFfscFindingsPl((prev) => prev.filter((item) => item !== number));
          break;
        case "areasOfConcern":
          setAreaConcernPl((prev) => prev.filter((item) => item !== number));
          break;
        case "auditDetails":
          // Audit details corrections are handled above
          break;
        case "auditConclusionData":
          setAuditConclusionPl((prev) => prev.filter((item) => item !== id));
          break;
        case "focusArea":
          setFocusAreaPl((prev) => prev.filter((item) => item !== id));
          break;
        default:
          setProtocolDetailsPl((prev) => prev.filter((item) => item !== id));
      }
    }
  };

  const handleAuditDetailsCorrectionStatusChange = (id, status) => {
    if (status === "verified") {
      // Remove the item entirely when marked as verified
      setAuditDetailsCorrections(prev => 
        prev.filter(correction => correction.id !== id)
      );
    } else {
      // Update the status when marked as needs correction
      setAuditDetailsCorrections(prev => 
        prev.map(correction => 
          correction.id === id 
            ? { ...correction, selectedStatus: status }
            : correction
        )
      );
    }
  };

  const getFormStage = async () => {
    const url = `${process.env.REACT_APP_SERVER_URL}/api/forms/get_audit_verify/${auditNumber}`;
    const token = await getToken();

    await fetch(`${url}`, {
      headers: {
        "oidc-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            // console.log(json);
            setUnitIndex(json?.unit_index || "");
            setVersion(json?.version || "");
          });
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getFormStage();
  }, []);

  // Update sendBackPopupFlag based on correctionData2 with isPreviousYear=true
  useEffect(() => {
    const hasPreviousYearItems = correctionData2.some(item => item.isPreviousYear === true);
    setSendBackPopupFlag(hasPreviousYearItems);
  }, [correctionData2]);

  useEffect(() => {
    if (submitData) {
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    }
  }, [submitData]);

  // useEffect(()=>{
  //   console.log("version")
  // },[version])
  return (
    <>
      <div id="mars-audit">
        <Box
          className="mainLayout"
          sx={{ display: "flex", overflow: "hidden" }}
        >
          <MainLayout />

          {submitData && (
            <div id="mainHome" className={submitData ? "mars-admin-home" : ""}>
              <div className="submitGif-box">
                <img src={responseSubmit} alt="submitgif" />
              </div>

              <Footer />
            </div>
          )}
          {!submitData && (
            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              {!verificationLoading && (
                <>
                  <div style={{ display: "grid" }} className="audit-id">
                    <span>Mars QMS Audit #: {auditNumber || "N/A"}</span>
                    <span
                      style={{
                        fontSize: "16px",
                        color: "#8d8d8d",
                        fontWeight: "500",
                      }}
                    >
                      Unit Index is #: {unitIndex || "N/A"}
                    </span>
                  </div>
                  <FormProgress />
                </>
              )}

              <div id="mainHome" className="mars-audit-container">
                {verificationLoading ? (
                  <>
                    <div
                      style={{
                        display: "grid",
                        alignContent: "center",
                        alignItems: "center",
                        justifyContent: "center",
                        justifyItems: "center",
                        gap: "20px",
                        height: "100%",
                      }}
                    >
                      <img src={iconLoading} width={100} alt="loading" />
                      <span style={{ fontSize: "24px" }}>
                        Please wait while loading the resources
                      </span>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="accordion-component "
                      style={{ marginTop: "40px", padding: "0px 80px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          paddingBottom: "10px",
                        }}
                      >
                        {verificationData && !verificationLoading && (
                          <TechReviewerNewExport
                            jsonData={verificationData}
                            sheetNames={[
                              "Unit Details",
                              "Audit details",
                              "Protocol details",
                              "Scoring details",
                              "Areas of Concern",
                              "PY-Areas of Concern",
                              "FSSC Findings",
                              "PY-FSSC Findings",
                            ]}
                            fileName={`${unitIndex}_${auditNumber}_${new Date().toISOString().split("T")[0]}`}
                            exportPosition="right" 
                            color="FF0000" 
                            type="excel" 
                          />
                        )}
                      </div>

                      <Accordion className="accordion-main">
                        <AccordionSummary
                          className="accordion-title"
                          expandIcon={
                            <ExpandMoreIcon className="arrow-white" />
                          }
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography component="span">Unit Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <FormDetailsTable
                            thirdCol={true}
                            formDetails={
                              verificationData?.unitDetails
                                ? verificationData?.unitDetails
                                : {}
                            }
                            error={verificationError}
                            tabName="unitDetails"
                          />
                        </AccordionDetails>
                      </Accordion>

                      <Accordion className="accordion-main">
                        <AccordionSummary
                          className="accordion-title"
                          expandIcon={
                            <ExpandMoreIcon className="arrow-white" />
                          }
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography component="span">
                            Audit Details
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          {" "}
                          <AuditDetailsTable
                            formDetails={
                              verificationData?.auditDetails
                                ? verificationData?.auditDetails
                                : {}
                            }
                            error={verificationError}
                            tabName="auditDetails"
                            onRadioChange={handleRadioButton}
                          />
                        </AccordionDetails>
                      </Accordion>

                      <Accordion className="accordion-main">
                        <AccordionSummary
                          className="accordion-title"
                          expandIcon={
                            <ExpandMoreIcon className="arrow-white" />
                          }
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography component="span">
                            Protocol Details
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <ProtocolDetails
                            protocolData={
                              verificationData?.protocolDetails
                                ? verificationData?.protocolDetails
                                : {}
                            }
                            onChangeRadio={handleRadioButton}
                            auditNumber={auditNumber}
                            error={verificationError}
                            versionData={
                              verificationData?.auditDetails
                                ? verificationData?.auditDetails
                                : {}
                            }
                          />
                        </AccordionDetails>
                      </Accordion>

                      <Accordion className="accordion-main">
                        <AccordionSummary
                          className="accordion-title"
                          expandIcon={
                            <ExpandMoreIcon className="arrow-white" />
                          }
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography component="span">
                            Scoring Details
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <ScoringDetails
                            scoringData={
                              verificationData?.scoringDetails
                                ? verificationData?.scoringDetails
                                : {}
                            }
                            error={verificationError}
                            onChangeRadio={handleRadioButton}
                            protocolData={
                              verificationData?.protocolDetails
                                ? verificationData?.protocolDetails
                                : {}
                            }
                          />
                        </AccordionDetails>
                      </Accordion>
                    </div>

                    {!verificationError && !verificationLoading && (
                      <div className="validate-btn-container1">
                        {/* <UploadFile
                          formId={auditNumber}
                          version={version}
                          getVerificationDetails={getVerificationDetails}
                        /> */}

                        <button
                          onClick={() => setOpenPopup(true)}
                          className={
                            correctionData1?.length === 0 &&
                            correctionData2?.length === 0 &&
                            auditDetailsCorrections.filter(item => item.selectedStatus === "correction").length === 0
                              ? "primary-btn-validate btn-tech"
                              : "secondary-btn-validate btn-tech"
                          }
                          disabled={
                            correctionData1?.length !== 0 ||
                            correctionData2?.length !== 0 ||
                            auditDetailsCorrections.filter(item => item.selectedStatus === "correction").length !== 0
                          }
                        >
                          Complete Tech Review
                        </button>
                        <button
                          onClick={() => setOpenCorrectionPopup(true)}
                          className={
                            correctionData1?.length > 0 ||
                            correctionData2?.length > 0 ||
                            auditDetailsCorrections.filter(item => item.selectedStatus === "correction").length > 0
                              ? "primary-btn-validate btn-tech"
                              : "secondary-btn-validate btn-tech"
                          }
                          disabled={
                            !(
                              correctionData1?.length > 0 ||
                              correctionData2?.length > 0 ||
                              auditDetailsCorrections.filter(item => item.selectedStatus === "correction").length > 0
                            )
                          }
                        >
                          Send Back
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
              <Footer />

              <Dialog
                open={openPopup}
                onClose={() => {
                  setOpenPopup(false);
                }}
                id="mars-admin-popup"
              >
                {submitLoading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "16px",
                      gap: "16px",
                    }}
                  >
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <p
                      style={{
                        fontSize: "18px",
                        marginBottom: "0",
                        color: "#0000a0 ",
                      }}
                    >
                      Submitting Response ...
                    </p>
                  </div>
                )}
                <DialogContent>
                  <div className="popup-text-container">
                    <p style={{ textAlign: "left" }}>Note *</p>
                    <ul>
                      <li>The audit data will be sent to data lake.</li>
                      <li>
                        If this audit has versioning, the Lead Auditor will be
                        notified to perform versioning.
                      </li>
                      <li>
                        If this is a completed audit with no versioning, a PDF
                        will be generated and "Completed" notification will be
                        triggered to the Unit Admin and Lead Auditor
                      </li>
                      {/* <li>If this is a completed audit with no versioning, a PDF will be generated and sent to the Unit Admin.</li> */}
                    </ul>
                    <p></p>
                    <p style={{ textAlign: "left", fontSize: "16px" }}>
                      Are you sure you want to continue?
                    </p>
                  </div>
                </DialogContent>
                <DialogActions
                  style={{
                    padding: "24px",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "40px",
                  }}
                >
                  <button
                    className="logout-popup-btn primary-btn mars-admin-popup"
                    onClick={() => {
                      submitForm("allGood");
                    }}
                    disabled={submitLoading}
                  >
                    Confirm
                  </button>
                  <button
                    className="logout-popup-btn secondary-btn mars-admin-popup"
                    onClick={() => {
                      setOpenPopup(false);
                    }}
                    disabled={submitLoading}
                  >
                    Cancel
                  </button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={openCorrectionPopup}
                onClose={() => {
                  setOpenCorrectionPopup(false);
                }}
                id="mars-admin-popup-correction"
              >
                {submitLoading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "16px",
                      gap: "16px",
                    }}
                  >
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <p
                      style={{
                        fontSize: "18px",
                        marginBottom: "0",
                        color: "#0000a0 ",
                      }}
                    >
                      Submitting Response ...
                    </p>
                  </div>
                )}
                <DialogContent>
                  {(() => {
                    const auditItemsNeedingCorrection = auditDetailsCorrections?.filter(item => item.selectedStatus === "correction") || [];
                    return auditItemsNeedingCorrection.length > 0 ? (
                      <div style={{ marginBottom: "16px" }}>
                        <h4 style={{ color: "#0000a0", marginBottom: "12px" }}>
                          {/* Audit Details - Needs Correction ({auditItemsNeedingCorrection.length} items): */}
                        </h4>
                        <AuditDetailsCorrectionTable
                          formDetails={auditItemsNeedingCorrection}
                          onStatusChange={handleAuditDetailsCorrectionStatusChange}
                          needCorrection={false}
                        />
                      </div>
                    ) : null;
                  })()}
                  {correctionData1 && correctionData1.length > 0 && (
                    <CommonTableOne
                      formDetails={correctionData1 ? correctionData1 : []}
                      tabName="correction1"
                      needCorrection={true}
                    />
                  )}
                  {correctionData2 && correctionData2.length > 0 && (
                    <div style={{ marginTop: "16px" }}>
                      <CommonTableTwo
                        formDetails={correctionData2 ? correctionData2 : []}
                        tabName="correction2"
                        needCorrection={true}
                        versionData={
                          verificationData?.auditDetails
                            ? verificationData?.auditDetails
                            : {}
                        }
                        sendBackPopupFlag={sendBackPopupFlag}
                      />
                    </div>
                  )}
                  <div>
                    <p
                      style={{
                        color: "#FC0505",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginTop: "24px",
                        textAlign: "center",
                      }}
                    >
                      Notify the Lead Auditor to correct the above details?
                    </p>
                  </div>
                </DialogContent>
                <DialogActions
                  style={{
                    padding: "24px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "40px",
                  }}
                >
                  <button
                    className="logout-popup-btn primary-btn mars-admin-popup"
                    onClick={() => {
                      submitForm("sendBack");
                    }}
                    disabled={submitLoading}
                  >
                    Yes
                  </button>
                  <button
                    className="logout-popup-btn secondary-btn mars-admin-popup"
                    onClick={() => {
                      setOpenCorrectionPopup(false);
                    }}
                    disabled={submitLoading}
                  >
                    No
                  </button>
                </DialogActions>
              </Dialog>
            </Box>
          )}
        </Box>
      </div>
      {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default TechReviewerAudit;
